<template lang="pug">
.searchPanel
  .simpleSearch(key="simpleSearch")
    form(@submit.prevent="$emit('pesquisar', filtro)")
      el-input.input(
        :placeholder="placeholder",
        v-model="filtro.campoSimplificado",
        class="input-with-select"
      )
        el-button.color-default(
          slot="append",
          icon="el-icon-search",
          @click="pesquisar"
        )
  .button-group
    .left-buttons
      el-button.no-padding(
        type="text",
        @click="limpar"
      ) Limpar
</template>

<script>
export default {

  props: {
    filtro: {
      type: Object,
      required: true
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Informe o ano'
    }
  },

  methods: {
    pesquisar () {
      this.$emit('pesquisar', this.filtro)
    },

    limpar () {
      this.$emit('limpar')
    }
  }
}
</script>

<style scoped lang="scss">
.searchPanel {
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  .button-group {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 15px;
  }

  .no-padding {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/FiltroPvtn.vue